export const howItWorksTimelineContent = {
  title: 'How it works',
  simArrives: 'Your SIM arrives in 2-5 days',
  eSim: ' or get started quickly with eSIM',
  activate: 'Activate your SIM in minutes',
  transfer: 'Transfer your number',
  referral: (value: number | string | undefined) =>
    `Bag up to a £${value ?? ''} gift card for referrals`,
}
